import React, { FC, useEffect } from 'react';
import { useConnect } from './connect';
import ReportView from './ReportView';
import { Loader, StateContainer, StateSubtitle, StateTitle } from './styles';
import { Props } from './types';

const MonthlyReport: FC<Props> = ({ className }) => {
  const { error, getReport, isPremium, loading, report } = useConnect();

  useEffect(() => {
    getReport();
  }, [getReport]);

  if (loading && !report) {
    return <Loader />;
  }

  if (error || !report) {
    return (
      <StateContainer>
        <StateTitle>We couldn’t load your monthly report.</StateTitle>
        <StateSubtitle>
          Please try again later or head back to the community.
        </StateSubtitle>
      </StateContainer>
    );
  }

  return (
    <ReportView className={className} isPremium={isPremium} report={report} />
  );
};

export default MonthlyReport;
